import React from 'react'
import classnames from 'classnames'
import styles from './index.module.css'

const Hr = ({ rootStyle }) => {
  return <hr className={classnames(styles.separate, rootStyle)} />
}

export default Hr
